export default __webpack_public_path__ + "media/images/close-377829b2.svg";